import { motion } from "motion/react";
import { useI18n } from "@/i18n/I18nContext";
import { PhoneMockup } from "@/landing/components/PhoneMockup";

const SCREENSHOT_COLORS = [
  "from-[#4CAF50] to-[#45a049]",
  "from-[#2196F3] to-[#1976D2]",
  "from-[#FFC857] to-[#FF9800]",
  "from-[#9C27B0] to-[#7B1FA2]",
  "from-[#F44336] to-[#D32F2F]",
] as const;

export function ScreenshotsSection() {
  const { messages } = useI18n();
  const s = messages.screenshots;

  return (
    <section className="bg-gradient-to-br from-[#F7F7F5] to-white py-32">
      <div className="container mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="mb-16 text-center"
        >
          <h2 className="mb-6 text-4xl text-[#111111] lg:text-6xl">
            {s.heading}
          </h2>
          <p className="mx-auto max-w-2xl text-xl text-gray-600">
            {s.subheading}
          </p>
        </motion.div>

        <div className="scrollbar-hide flex gap-8 overflow-x-auto px-4 pb-8">
          {s.items.map((screenshot, index) => (
            <motion.div
              key={screenshot.title}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="shrink-0"
            >
              <PhoneMockup>
                <div
                  className={`flex h-full items-center justify-center bg-gradient-to-br ${SCREENSHOT_COLORS[index] ?? SCREENSHOT_COLORS[0]}`}
                >
                  <div className="p-6 text-center text-white">
                    <h3 className="mb-4 text-2xl">{screenshot.title}</h3>
                    <div className="mx-auto h-16 w-16 rounded-full bg-white/20" />
                  </div>
                </div>
              </PhoneMockup>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
